import type { FormEvent } from "react";

import { Button, ButtonTypes } from "../basic/button";
import { Loading } from "../basic/loading";
import TextBox from "../basic/textBox";
import { LoginBackground } from "./background";

interface Props {
	username: string;
	setUsername: (value: string) => void;
	submitFunction: (event: FormEvent<HTMLFormElement>) => void;
	goBack?: () => void;
	loading: boolean;
	disabled: boolean;
	version?: string;
	error?: string;

	appLogo?: string;
	backgroundImage?: string;
}

export function ForgotPasswordPage(props: Props) {
	const {
		username,
		setUsername,
		submitFunction,
		goBack,
		loading,
		disabled,
		version,
		error,
		appLogo,
		backgroundImage,
	} = props;

	return (
		<LoginBackground version={version} appLogo={appLogo} backgroundImage={backgroundImage}>
			<form className="grid gap-4" onSubmit={submitFunction}>
				<TextBox
					id="username"
					name="username"
					label="Username"
					value={username}
					changeHandler={setUsername}
					className="!m-0"
					disabled={disabled}
				/>
				{error !== undefined && <span className="text-sm text-red-400">{error}</span>}
				<Loading loading={loading} message="Logging in...">
					<Button type="submit" className="w-full" types={[ButtonTypes.Primary]} disabled={disabled}>
						Submit
					</Button>
				</Loading>
				{goBack && (
					<Button
						type="submit"
						className="w-full"
						types={[ButtonTypes.Outline]}
						disabled={disabled}
						onClick={goBack}
					>
						Go Back
					</Button>
				)}
			</form>
		</LoginBackground>
	);
}
